/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ClientSessionBookingDto = {
    /**
     * Booking UUID
     */
    bookingId: string;
    /**
     * Booking type
     */
    bookingType: ClientSessionBookingDto.bookingType;
    /**
     * Session type
     */
    sessionType?: ClientSessionBookingDto.sessionType;
    /**
     * Total amount
     */
    totalAmount?: Record<string, any>;
    /**
     * Currency code
     */
    currency: string;
    /**
     * Payment status
     */
    paymentStatus?: ClientSessionBookingDto.paymentStatus;
    /**
     * Package name
     */
    packageName?: Record<string, any>;
    /**
     * Booking status
     */
    status: ClientSessionBookingDto.status | null;
    /**
     * Total sessions
     */
    totalSessions: number;
    /**
     * Completed sessions
     */
    completedSessions: number;
    /**
     * Session progress
     */
    sessionProgress: string;
    /**
     * Package validity start date
     */
    packageValidityStart?: string | null;
    /**
     * Package validity end date
     */
    packageValidityEnd?: string | null;
    /**
     * Cancellation dispute status
     */
    disputeStatus?: ClientSessionBookingDto.disputeStatus | null;
    /**
     * Refund amount
     */
    refundAmount?: number | null;
    /**
     * Refund status
     */
    refundStatus?: ClientSessionBookingDto.refundStatus | null;
};
export namespace ClientSessionBookingDto {
    /**
     * Booking type
     */
    export enum bookingType {
        PACKAGE = 'package',
        SINGLE_SESSION = 'single_session',
    }
    /**
     * Session type
     */
    export enum sessionType {
        SINGLE = 'single',
        DUO = 'duo',
    }
    /**
     * Payment status
     */
    export enum paymentStatus {
        PENDING = 'pending',
        COMPLETED = 'completed',
        FAILED = 'failed',
        REFUNDED = 'refunded',
    }
    /**
     * Booking status
     */
    export enum status {
        PENDING = 'pending',
        ACTIVE = 'active',
        COMPLETED = 'completed',
        CANCELLED = 'cancelled',
        PAYMENT_FAILED = 'payment_failed',
        PAYMENT_FAILED_RETRYABLE = 'payment_failed_retryable',
    }
    /**
     * Cancellation dispute status
     */
    export enum disputeStatus {
        PENDING = 'pending',
        IN_REVIEW = 'in_review',
        RESOLVED = 'resolved',
        DECLINED = 'declined',
    }
    /**
     * Refund status
     */
    export enum refundStatus {
        PENDING = 'pending',
        APPROVED = 'approved',
        DECLINED = 'declined',
        PROCESSED = 'processed',
        FAILED = 'failed',
    }
}

